<template>
    <div class="com-part4">
        <!-- <MyTitle title="PUE" subTitle="PUE" /> -->
        <!-- <div class="pue-list flex align-center mt-50">
            <div
                v-for="(item, i) in pueList" :key="'pueList' + i"
                class="flex1 pue-item flex flex-direction align-center">
                <dv-water-level-pond :config="pondConfig(item)" style="width: 168px; height: 168px" />
                <p class="label mt-10">{{ item.label }}</p>
            </div>
        </div> -->
        <!-- <MyTitle class="mt-20" type="2" title="用量趋势" /> -->
        <!-- <div class="sub-title flex justify-end align-center">
            <div
                v-for="(item, i) in subTitle" :key="'subTitle' + i"
                @click="subTitleChange(i)">
                <p :class="{'at': i == subTitleAt}">{{ item.label }}</p>
            </div>
        </div> -->
		 <title1 type="2" title="出租率" style="margin-top: 30px" />
        <div class="p-content flex align-center">
            <myEchart
                v-if="show1"
                :id="'show1'"
                :options="batteryChargingData" />
        </div>
    </div>
</template>

<script>
import title1 from '@/views/exposition/components/title1'
import myEchart from "../charts/echarts"
import { dataInterface } from "@/api/dataInterfaceApi"
import { formatTime } from '@/utils/index'
import mySmallTitle from '../mySmallTitle.vue'
import * as echarts from 'echarts5'
export default {
    components: {
        title1,
        myEchart,
        mySmallTitle
    },
    data() {
        return {
            pueList: [
                {
                    label: 'GPU使用率',
                    value: '50',
                },
                {
                    label: 'CPU使用率',
                    value: '59',
                },
                {
                    label: '内存使用率',
                    value: '90',
                }
            ],
            subTitle: [
                {
                    label: 'GPU'
                },
                {
                    label: 'CPU'
                },
                {
                    label: '内存'
                },
                {
                    label: '存储'
                }
            ],
            subTitleAt: 0,
            // 充电参数实时检测
            show1: false,
            batteryChargingData: {}
        }
    },
	mounted() {
        // 充电参数实时检测
        this.getbatteryCharging1()
    },
	methods: {
		// 水位图 config
		pondConfig( item = {} ) {
			let config = {
				data: [parseFloat(item.value || 0)],
				shape: 'round'
			}
			return config
		},
        // 副标题切换
        subTitleChange(i) {
            this.subTitleAt = i
        },
        // 充电参数实时检测
        getbatteryCharging1() {
			let params = { 
				enCode: 'computingpower-right-czl',
			}
			dataInterface.dataFaceApi(params).then(res => {
				console.log(res, '出租率')
				let xAxisData = []
				let data1 = []
				let data2 = []
				res.forEach(item => {
					xAxisData.push(item.pday)
					data1.push(item.measure)
					// data2.push(item.type)
				})
                this.batteryChargingData = {
                    title: {
                        text: '  %    ',
                        textStyle: {
                            fontSize: 20 // 设置标题字体大小
                        }
                    },
                    color: ['#4fc1ef', '#8bcfd0'],
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'shadow'
                        }
                    },
                    xAxis: {
                        type: 'category',
                        data: xAxisData,
                        axisLabel: {
                            textStyle: {
                            color: '#ccc',
                            fontSize: '20'
                            }
                        }
                    },
                    yAxis: {
                        type: 'value',
                        axisLabel: {
                            textStyle: {
                            color: '#ccc',
                            fontSize: '20'
                            }
                        }
                    },
                    series: [
                        {
                            name: '',
                            type: 'line',
                            smooth: true,
                            lineStyle: {
                                width: 0
                            },
                            showSymbol: false,
                            label: {
                                show: true,
                                position: 'top'
                            },
                            lineStyle: {
                                width: 2,
                                color: '#4fc1ef'
                            },
                            areaStyle: {
                                opacity: 0.8,
                                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                {
                                    offset: 0,
                                    color: '#2B8FEB'
                                },
                                {
                                    offset: 1,
                                    color: '#70A1CE'
                                }
                                ])
                            },
                            tooltip: {
                                valueFormatter: function (value) {
                                    return value + ' %';
                                }
                            },
                            emphasis: {
                                focus: 'series'
                            },
                            data: data1
                        },

                    ]
                }
				this.show1 = true
			})
        }
    }
}
</script>

<style lang="scss" scoped>
@import '../comm.scss';
.com-part4 {
    width: 100%;
    height: 600px;
    .pue-list {
        // height: 162px;
        .pue-item {
            height: 100%;
            // background: url(~@/assets/images/computility/dispatch-icon5.png) center no-repeat;
            // background-size: 165px 162px;
            > p {
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: $FontSize24;
            }
            .label {
                height: 38px;
            }
            .value {
                font-family: 'DS-Digital-Bold';
                font-size: $FontSize30;
            }
        }
    }
	.sub-title {
        font-size: $FontSize20;
        // padding-top: 20px;
        height: 50px;
        > div {
            padding-right: 20px;
            > p {
                text-shadow: 0px 0px 9px #03B9BD;
                padding: 0 10px;
                position: relative;
                cursor: pointer;
                &.at {
                    &::after {
                        position: absolute;
                        bottom: -10px;
                        left: 0;
                        content: '';
                        width: 100%;
                        height: 2px;
                        background: linear-gradient(270deg, rgba(113, 186, 188, 0.0001) 0%, #71BBBD 33.33%, #6DB5B7 66.67%, rgba(111, 185, 187, 0.0001) 100%);
                    }
                }
            }
        }
    }

    .p-content {
        width: 100%;
        height: 500px;
    }
}
</style>